import textJson from "../config/text.json";

export const t = (stringId) => {
  const strings = textJson;
  return strings[stringId];
};

export const tf = (stringId, placeholder) => {
  const strings = textJson;
  const foundString = strings[stringId];
  return foundString.replace("{{placeholder}}", placeholder);
};

export const getWeekDay = (dateString, compact = false) => {
  const weekDays = ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];
  dateString = dateString.replace(" ", "T");
  const date = new Date(dateString);
  if (isToday(date) || isTomorrow(date)) return "";

  return compact ? weekDays[date.getDay()].substring(0, 3) : weekDays[date.getDay()];
};

const isToday = (dateOne) => {
  const today = new Date();

  return dateOne.getDate() == today.getDate() && dateOne.getMonth() == today.getMonth() && dateOne.getFullYear() == today.getFullYear();
};

const isTomorrow = (dateOne) => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  return dateOne.getDate() == tomorrow.getDate() && dateOne.getMonth() == tomorrow.getMonth() && dateOne.getFullYear() == tomorrow.getFullYear();
};

export const getFullDateString = (dateString) => {
  const dayAndMonth = getDayAndMonth(dateString);
  let weekDay = "";
  if ("Oggi" != dayAndMonth && "Domani" != dayAndMonth) {
    weekDay = getWeekDay(dateString);
  }
  return `${weekDay} ${dayAndMonth}`;
};

export const getDayAndMonth = (dateString, compact = false) => {
  const months = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
  dateString = dateString.replace(" ", "T");
  const date = new Date(dateString);
  if (isToday(date)) return "Oggi";
  if (isTomorrow(date)) return "Domani";

  return `${date.getDate().toString().padStart(2, "0")} ${compact ? "<br />" : ""} ${compact ? months[date.getMonth()].substring(0, 3) : months[date.getMonth()]}`;
};

export const getFullHour = (hour) => {
  return hour.toString().padStart(2, "0");
};
export const getFullMinute = (minute) => {
  return minute.toString().padStart(2, "0");
};
export const getFullHourAndMinute = (hour, minute) => {
  return `${getFullHour(hour)}:${getFullMinute(minute)}`;
};

export const getYMD = (date) => {
  return date.substring(0, 10);
};

export const getYMDandHour = (date, hour) => {
  const dateString = getYMD(date);
  const hourString = `${getFullHour(hour.hour)}:${getFullMinute(hour.minute)}`;

  return `${dateString} ${hourString}`;
};

export const getTodayAsYMDandHour = () => {
  const date = new Date();
  const dateString = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getDate()}`;
  const hourString = getFullHourAndMinute(date.getHours(), date.getMinutes());

  return `${dateString} ${hourString}`;
};

export const randString = (length) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};
